import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/snapbox-landingpage/src/providers/I18nProvider.tsx");
